export enum OrderPlanningMode {
  AUTO = 'auto',
  MANUAL = 'manual',
  OUTSOURCING = 'outsourcing',
}
